import React, { Component } from "react";
import ReactDOM from "react-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Loadable from "@react-loadable/revised";
import fp from "lodash/fp";
import theme from "@styles/theme";
import { IconAdd, IconCancelCircle, ImageCategoryGroupOn } from "@mzc-cloudplex/icons";
import MetadataUseStatusTooltip from "../../components/tooltip/MetadataUseStatusTooltip";
import { CATEGORY_TYPES } from "@constants";
import { Chip, Grid, IconButton, Stack, Typography } from "@mzc-pdc/ui";

const LoadableSelectCategoriesModal = Loadable({
    loader: () => import("../../components/modals/SelectCategories"),
    loading: () => null,
});

const LoadableSelectCategoryGroupModal = Loadable({
    loader: () => import("../../components/modals/SelectCategoryGroup"),
    loading: () => null,
});

//TODO multi select 통합 필요 -> upload job cateogry
class Categories extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectCategoriesModal: false,
            selectCategoryGroupModal: false,
            selectedValues: [],
            categoryGroup: null,
        };
    }

    _componentUmounted = false;

    componentWillUnmount = () => {
        this._componentUmounted = true;
    };
    componentDidMount = async () => {
        this.setState({ ...this.state, selectedValues: this.props.selectedValues });
    };

    componentDidUpdate = (prevProps, prevState, snapshot) => {
        if (this._componentUmounted) {
            return;
        }

        if (!fp.isEqual(prevProps.selectedValues, this.props.selectedValues)) {
            this.setState({ ...this.state, selectedValues: this.props.selectedValues });
        }
    };

    onDeleteSelectedCategory = (deleteItem) => {
        const categories = this.state.selectedValues.filter((v) => v.id != deleteItem.id);
        if (this.props.categoryGroups) {
            this.props.onChange({
                categories: categories,
                categoryGroup: this.props.selectedCategoryGroup,
                inUse: this.state.projectCategoryUseStatue,
            });
        } else {
            this.props.onChange(categories);
        }
    };

    onDeleteSelectedCategoryAll = (deleteItems) => {
        if (this.props.categoryGroups) {
            this.props.onChange({ categories: deleteItems, categoryGroup: this.props.selectedCategoryGroup });
        } else {
            this.props.onChange(deleteItems);
        }
    };

    openSelectCategories = () => {
        if (!this.state.selectCategoriesModal) {
            this.props.onChangeModalOpen(!this.state.selectCategoriesModal);
        }

        this.setState({
            ...this.state,
            selectCategoriesModal: !this.state.selectCategoriesModal,
        });
    };

    openSelectCategoriesGroup = () => {
        if (!this.state.selectCategoryGroupModal) {
            this.props.onChangeModalOpen(!this.state.selectCategoryGroupModal);
        }

        this.setState({
            ...this.state,
            selectCategoryGroupModal: !this.state.selectCategoryGroupModal,
        });
    };

    render() {
        const { t } = this.props;
        return (
            <React.Fragment>
                {this.state.selectCategoriesModal &&
                    ReactDOM.createPortal(
                        <LoadableSelectCategoriesModal
                            initStateEvent={this.openSelectCategories}
                            type={this.props.type}
                            projectId={this.props.projectId}
                            selectedCategories={this.state.selectedValues}
                            onSelectedCategories={(option, categoryGroup) => this.props.onChange(option, categoryGroup)}
                            onModalClose={(v) => {
                                this.props.onChangeModalOpen(v);
                            }}
                            maxCount={this.props.maxCount}
                        />,
                        document.body,
                    )}

                {this.state.selectCategoryGroupModal &&
                    ReactDOM.createPortal(
                        <LoadableSelectCategoryGroupModal
                            maxCount={this.props.maxCount}
                            initStateEvent={this.openSelectCategoriesGroup}
                            type={this.props.type}
                            projectId={this.props.projectId}
                            defaultCategoryGroup={this.props.defaultCategoryGroup}
                            selectedCategories={this.props.selectedValues}
                            selectedCategoryGroup={this.props.selectedCategoryGroup}
                            onSelectedCategories={(option) => this.props.onChange(option)}
                            onModalClose={(v) => {
                                this.props.onChangeModalOpen(v);
                            }}
                        />,
                        document.body,
                    )}

                {!this.props.hiddenCategoryGroupLabel &&
                    this.props.selectedValues?.length > 0 &&
                    this.props.selectedCategoryGroup.id && (
                        <Grid container alignItems={"center"} gap={0.75} mb={1}>
                            <ImageCategoryGroupOn width={16} height={16} />
                            <Typography variant={"body1_700"}>{this.props.selectedCategoryGroup?.label}</Typography>
                            {![CATEGORY_TYPES.METADATA_TEMPLATE, CATEGORY_TYPES.CUSTOM_CONTENTS].includes(
                                this.props.type,
                            ) && (
                                <MetadataUseStatusTooltip
                                    id={this.props.id}
                                    tooltipDisabled={this.props.tooltipDisabled}
                                    anchorOrigin={{
                                        vertical: "center",
                                        horizontal: "right",
                                    }}
                                    transformOrigin={{
                                        vertical: "center",
                                        horizontal: "left",
                                    }}
                                    categoryGroupId={this.props.selectedCategoryGroup.id}
                                    categoryType={this.props.type}
                                />
                            )}
                        </Grid>
                    )}

                <div
                    className={`category-select ${this.props.isEdit && "is-edit"}`}
                    style={{
                        ...(this.props.isEdit && {
                            "& .MuiOutlinedInput-root": {
                                backgroundColor: `#fff`,
                                borderRadius: "2px",
                                "> fieldset": { borderColor: "#2763ea" },
                            },
                        }),
                    }}
                >
                    <div
                        className={"category-group"}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            paddingRight: "12px",
                            backgroundColor: "transparent",
                        }}
                    >
                        {!this.props.selectedValues || this.props.selectedValues.length <= 0 ? (
                            <div className={"category-label-empty"} style={{ color: theme.palette.greySecondary[400] }}>
                                {this.props.placeholder}
                            </div>
                        ) : (
                            <div
                                className={"category-label-group"}
                                style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "4px", flex: 1 }}
                            >
                                {this.props.selectedValues &&
                                    this.props.selectedValues.map((category) => (
                                        <Chip
                                            size={"small"}
                                            key={category.id}
                                            label={category.label}
                                            onDelete={(e) => {
                                                e.stopPropagation();
                                                this.onDeleteSelectedCategory(category);
                                            }}
                                            sx={{
                                                maxWidth: 200,
                                            }}
                                        />
                                    ))}
                            </div>
                        )}

                        <div style={{ paddingRight: "6px" }}>
                            <IconButton
                                circled
                                size={"small"}
                                hidden={!this.props.selectedValues || this.props.selectedValues.length <= 0}
                                onClick={(e) => {
                                    this.onDeleteSelectedCategoryAll([]);
                                }}
                            >
                                <IconCancelCircle size={16} htmlColor={"#939BB7"} />
                            </IconButton>
                        </div>
                        {this.props.categoryGroups ? (
                            <IconButton
                                circled
                                size={"small"}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.openSelectCategoriesGroup();
                                }}
                            >
                                <IconAdd size={16} />
                            </IconButton>
                        ) : (
                            <IconButton
                                sx={{ left: 0 }}
                                circled
                                size={"small"}
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.openSelectCategories();
                                }}
                            >
                                <IconAdd size={16} />
                            </IconButton>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

let mapStateToProps = (state) => {
    return {
        stage: state.stage,
        project: state.project,
    };
};
let mapDispatchToProps = (dispatch) => {
    return {};
};

const ConnectedCategories = connect(mapStateToProps, mapDispatchToProps)(Categories);

ConnectedCategories.defaultProps = {
    onChangeModalOpen: () => {},
    selectedCategoryGroup: {},
    hiddenCategoryGroupLabel: false,
};
export default withTranslation()(ConnectedCategories);
